import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { AuthRedirectGuard } from './auth/guards/auth-redirect.guard';


export const routes: Routes = [
  { path: "", redirectTo: "views", pathMatch: "full" },
  {
    path: "home",
    loadChildren: () => import('@root/home/home.module.ts').then(m => m.HomeModule),
    canLoad: [AuthGuard]
  },
  {
    path: "auth",
    loadChildren: () => import('@root/auth/auth.module.ts').then(m => m.AuthModule),
    canLoad: [AuthRedirectGuard]
  },
  {
    path: "configuration",
    loadChildren: () => import('@root/configuration/configuration.module.ts').then(m => m.ConfigurationModule),
    canLoad: [AuthGuard]
  },
  {
    path: "views",
    loadChildren: () => import('@root/views/views.module.ts').then(m => m.ViewModule)
  },
  {
    path: "management",
    loadChildren: () => import('@root/management/management.module.ts').then(m => m.ManagementModule)
  },
  { path: "**", redirectTo: "/views/queries" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
